import { Injectable } from "@angular/core";
import { Template } from "../models/template-model";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class TemplateMasterService {
  constructor(private http: HttpClient) {}

  lFN_GetTemplateMasterList() {
    return this.http.get(`${environment.ROOT_URL}/template`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveUpdateTemplate(payload: Template) {
    return this.http.post(`${environment.ROOT_URL}/template`, payload,
      {
        withCredentials: false,
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
  }

  lFN_GetTemplateById(templateId: number) {
    return this.http.get(`${environment.ROOT_URL}/template/template-id/${templateId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_ChangeTemplateStatus(templateId: number) {
    return this.http.patch(`${environment.ROOT_URL}/template/status/${templateId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

}